import { render } from "./DocumentLocationCreate.vue?vue&type=template&id=167b45d6"
import script from "./DocumentLocationCreate.vue?vue&type=script&lang=js"
export * from "./DocumentLocationCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__